import { useState } from "react";
import { CalendarDays } from "lucide-react";
import { es } from "date-fns/locale";
import { Calendar } from "@/components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { formatDate } from "@/lib/format";

const toISO = (d: Date) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
const fromISO = (iso: string) => (iso ? new Date(Number(iso.slice(0, 4)), Number(iso.slice(5, 7)) - 1, Number(iso.slice(8, 10))) : undefined);

export function DatePicker({ value, onChange, testId }: { value: string; onChange: (iso: string) => void; testId: string }) {
  const [open, setOpen] = useState(false);
  const selected = fromISO(value);
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" className="tabular flex h-11 w-full items-center justify-between rounded-md border border-input bg-white px-3 text-left text-sm text-[#1B2A4A] transition-colors hover:border-[#1B2A4A]" data-testid={testId}>
          {value ? formatDate(value) : <span className="text-slate-400">Elige una fecha</span>}
          <CalendarDays className="h-4 w-4 text-slate-400" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-auto bg-white p-0" align="start" data-testid={`${testId}-popover`}>
        <Calendar mode="single" locale={es} selected={selected} defaultMonth={selected} weekStartsOn={1}
          onSelect={(d?: Date) => { if (d) { onChange(toISO(d)); setOpen(false); } }} />
      </PopoverContent>
    </Popover>
  );
}
